module.exports = __webpack_public_path__ + "img/volume-max.55d4761f.svg";